﻿import { sectioneiformulaeditor } from './sectioneiformulaeditor.js';

window.sectioneiformulaeditor_left = function () {
    var instance = {
        setonclicks_contr_clause: function () {

            var _this = this;
            _this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-cl-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addclausecontract');
                a.addEventListener("click", function () {
                    _this.sectioneiformulaeditor.addclausecontract(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-cl-setClick", "true");
            });
            
        },
        setonclicks_contr: function () {
            var _this = this;
            _this.sectioneiformulaeditor = new sectioneiformulaeditor();
             document.querySelectorAll("a[data-ot-ctr-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addcontract');
                a.addEventListener("click", function () {
                    _this.sectioneiformulaeditor.addcontract(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-ctr-setClick", "true");
            });
        },

        setonclicks_sectionei: function () {
            var _this = this;
            _this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-ctr-ei-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addsectionei');
                a.addEventListener("click", function () {
                    _this.sectioneiformulaeditor.addsectionei(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-ctr-ei-setClick", "true");
            });
        },
        setonclicks_sectiondataei: function () {
            var _this = this;
            _this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-ctr-dataei-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-adddatasectionei');
                a.addEventListener("click", function () {
                    _this.sectioneiformulaeditor.adddatasectionei(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-ctr-dataei-setClick", "true");
            });
        }
    }
    return instance;
}();